import { Flex, Link, SortUpIcon, Typography } from '@iheartjane/reefer';
import type { SortDirection, SortingState } from '@tanstack/react-table';

interface SortableColumn {
  getIsSorted: () => false | SortDirection;
  id: string;
  toggleSorting: (desc?: boolean) => void;
}

export const SortableHeader = ({
  column,
  headerText,
  sorting,
  shiftRight = false,
}: {
  column: SortableColumn;
  headerText?: string;
  shiftRight?: boolean;
  sorting: SortingState;
}) => {
  const margin = shiftRight ? 64 : 0;
  const sortedColumn = sorting[0] ? sorting[0].id : null;

  return (
    <Flex alignItems="center" ml={margin}>
      <Link
        onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        variant="minimal"
      >
        <Flex alignItems="center">
          <Typography variant="caps-regular">{headerText}</Typography>
          <SortUpIcon
            color={sortedColumn === column.id ? 'primary-light' : 'default'}
            rotate={column.getIsSorted() === 'asc' ? 'up' : 'down'}
          />
        </Flex>
      </Link>
    </Flex>
  );
};
